import MapperBase from '../MapperBase.js';
import OutType from '../../enums/OutType.js';

class MlbOutTypeMapper extends MapperBase {
    constructor(silent) {
        super(silent, OutType.Out.key);
    }

    /**
     * 
     * @param {*} item from liveData.plays.allPlays[*].runners[*].details
     * @returns {String} - value from OutType enum
     */
    mapSingle(item) {
        // Unfortunately there is no api doc containing all possible values for this...
        switch (item.eventType) {
            case 'field_out': // TODO - mauybe we also need home run type ?
                switch (item.event) {
                    // actually we also have a different types here
                    case 'Flyout':
                        return OutType.FlyOut.key;
                    case 'Groundout':
                        return OutType.GroundOut.key;
                    case 'Pop Out':
                        return OutType.PopOut.key;
                    case 'Lineout':
                        return OutType.LineOut.key;
                }
                return OutType.FieldOut.key;
            case 'strikeout':
            case 'strikeout_double_play':
                return OutType.Strikeout.key;
            case 'force_out':
                return OutType.ForceOut.key;
            case 'double_play':
                return item.movementReason === null
                ? OutType.AirOut.key
                : OutType.DoublePlay.key; // TODO - movemnt reason is actually r_doubled_off or r_thrown_out then
            case 'triple_play':
                return item.movementReason === null
                ? OutType.AirOut.key
                : OutType.TriplePlay.key;
            case 'grounded_into_double_play':
                return item.movementReason === null
                    ? OutType.GroundOut.key
                    : OutType.ForceOut.key; // TODO - maybe double play here?
            case 'pickoff_3b':
            case 'pickoff_2b':
            case 'pickoff_1b':
                return OutType.Pickoff.key;
            case 'caught_stealing_2b':
            case 'caught_stealing_3b':
            case 'caught_stealing_home':
                return OutType.CaughtStealing.key;
            case 'sac_fly':
            case 'sac_bunt':
                return OutType.Sacrifice.key;
            case 'other_out': // TODO - maybe we could use also movementReason like r_thrown_out here
            case 'fielders_choice_out': // r_runner_out goes here
                return OutType.Out.key;
        }

        throw new Error(`Unable to map runner out of type ${item.eventType}, event ${item.event}`);
    }
}

export default MlbOutTypeMapper;